export default __webpack_public_path__ + "static/media/es-laughing.57b478db.jpg";